import { render, staticRenderFns } from "./ContactLayout.vue?vue&type=template&id=30c31aa6&scoped=true"
import script from "./ContactLayout.vue?vue&type=script&lang=js"
export * from "./ContactLayout.vue?vue&type=script&lang=js"
import style0 from "./ContactLayout.vue?vue&type=style&index=0&id=30c31aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c31aa6",
  null
  
)

export default component.exports